import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AfterViewChecked, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AppService } from '../app.service';
import { SafeHtmlPipe } from '../templates/safe.pipe';
import { HtmlReport } from './report.models';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SafeHtmlPipe],
})
export class ReportComponent implements OnInit, AfterViewChecked {
  isReportLoaded: boolean = false;
  isDownloadButtonActivated: boolean = false;
  reportBody: string = '';
  http: HttpClient;
  downloadButton: ElementRef;

  assessmentBaseUrl: string = '';

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
    params: {
      ReportCode: '62000',
    },
  };

  constructor(
    private appService: AppService,
    http: HttpClient,
  ) {
    this.http = http;
  }

  @ViewChild('reportContainer') reportContainer: ElementRef;

  ngOnInit() {
    this.appService.getUserDetails().subscribe(
      (data) => {
        this.assessmentBaseUrl = data.assessmentSiteBaseUrl;
      },
      () => {},
    );
    this.loadReportPage();
  }

  ngAfterViewChecked() {
    let scripts = this.reportContainer.nativeElement.getElementsByTagName('script');
    for (let script of scripts) {
      eval(script.text);
    }
  }

  loadReportPage() {
    this.isReportLoaded = true;

    this.http.get<HtmlReport>('/api/report', this.httpOptions).subscribe(
      (result) => {
        this.reportBody = result.content;
        this.isReportLoaded = true;
        let scripts = this.reportContainer.nativeElement.getElementsByTagName('script');
        for (let script of scripts) {
          eval(script.text);
        }
      },
      (error) => {
        console.error(error);
        this.isReportLoaded = true;
      },
    );
  }
}
